// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1dKr8","filesListContainer":"PosDisputesFiles_filesListContainer__2owtP","filesButton":"PosDisputesFiles_filesButton__QCvK_"};